import React from "react";
import { Typography, Box } from "@mui/material";
import Button from "@mui/material/Button"
import {CheckCircle as CheckCircleIcon} from "@mui/icons-material";
import axios from "axios";
import { getAuthHeaders } from "../../context/AuthContext";
import { getApiUrl } from "../../utils/apiHelper";
import { useAuth } from "../../context/AuthContext";

export default function ReportFoundButton({ image_key, sku, rank, reported, setReported }) {
  const { loginType } = useAuth();
  
  const handleReportFound = async () => {
    try {
      const headers = await getAuthHeaders();
      const response = await axios.post(
        getApiUrl(loginType, "/report/image/found"),
        { 
          image_key: image_key,
          sku: sku,
          rank: rank
        },
        { headers }
      );
      if (response.status === 200) {
        console.log("Report submitted successfully");
        setReported(true);
      } else {
        console.log("Failed to submit report");
      }
    }
    catch (error) {
      console.error("Error reporting found item:", error);
    }   
  };

    return (
        <Box display="flex" flexDirection="column" alignItems="flex-start"  sx={{ mt: 2 }}>
            <Button
                variant="outlined"
                color="success"
                startIcon={ <CheckCircleIcon />}
                disabled={reported}
                onClick={handleReportFound}
                sx= {{ px: 4, py: 1.2, borderRadius: 2, ml: 0, fontSize: '0.875rem', fontWeight: 500, textTransform: 'none' }}
            >
                {!reported? "Report Found": "Already Reported"}
            </Button>
            <Typography variant="caption" color="text.secondary" sx={{ mt: 0.1, ml: 1 }}>
                Confirm this SKU is correct
            </Typography>
        </Box>
    )
}